import { render } from "./WeekList.vue?vue&type=template&id=d35a7cf2"
import script from "./WeekList.vue?vue&type=script&lang=js"
export * from "./WeekList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__